const clock = document.querySelector('[data-clock]');

function updateClock()
{
    const now = new Date();
    clock.textContent = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
}

if (clock) {
    setInterval(updateClock, 1000);
}
